if (!customElements.get("switch-column")) {
  customElements.define(
    "switch-column",
    class SwitchColumn extends HTMLElement {
      static MOBILE_WIDTH_BREAKPOINT = 600;

      constructor() {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      initialize() {
    this.container = this.querySelector(".collection__mobile-layout-switch");
    this.loader = this.querySelector(".loading-overlay");
    this.collectionGrid = document.querySelector(".collection__gridd");
    this.checkInput = document.querySelector(".collection__mobile-layout-checkbox");
    this.gridButton = this.container.querySelector(".css-icon--grid");
    this.colsButton = this.container.querySelector(".css-icon--cols");
    this.squareButton = this.container.querySelector(".css-icon--square");
    this.sortCustomSelect = document.querySelector('[data-reference-id="SortBy"]');

    this.boundChangeNumberOfColumns = this.changeNumberOfColumns.bind(this);
    this.boundHandleResize = this.handleResize.bind(this);
    this.boundHandleLoad = this.handleLoad.bind(this);

    this.gridButton.classList.add("active");

    this.addEventListeners();
}

      addEventListeners() {
        window.addEventListener("load", this.boundHandleLoad);
        window.addEventListener("resize", this.boundHandleResize);
        this.sortCustomSelect.addEventListener(
          "wtSelectChange",
          this.boundHandleLoad,
        );
        this.container.addEventListener(
          "click",
          this.boundChangeNumberOfColumns,
        );
      }

      removeEventListeners() {
        window.removeEventListener("load", this.boundHandleLoad);
        window.removeEventListener("facets:change", this.boundHandleLoad);
        window.removeEventListener("resize", this.boundHandleResize);
        this.container.removeEventListener(
          "click",
          this.boundChangeNumberOfColumns,
        );
        this.sortCustomSelect.removeEventListener(
          "wtSelectChange",
          this.boundHandleLoad,
        );
      }

      handleLoad() {
        this.loader.classList.add("loading-overlay--hidden");
        this.container.classList.remove(
          "collection__mobile-layout-switch--hidden",
        );
        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        }
      }

      handleResize() {
        if (
          window.innerWidth >= SwitchColumn.MOBILE_WIDTH_BREAKPOINT &&
          this.collectionGrid.style.getPropertyValue("--cols")
        ) {
          this.collectionGrid.style.removeProperty("--cols");
        } else if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          if (!this.loader.classList.contains("loading-overlay--hidden")) {
            this.loader.classList.add("loading-overlay--hidden");
          }
            if (
              this.container.classList.contains(
                "collection__mobile-layout-switch--hidden",
              )
            ) {
              this.container.classList.remove(
                "collection__mobile-layout-switch--hidden",
              );
            }
            this.setNumberOfColumns();
        }
      }

      takeFromLocalStorage() {
        return localStorage.getItem("numberOfColumns");
      }

      setInLocalStorage(value) {
        localStorage.setItem("numberOfColumns", value);
      }

      getNumberOfColumns() {
        if (this.dataset.designMode === "true") {
          return this.dataset.col;
        } else {
          const valueFromLocalStorage = this.takeFromLocalStorage();
          const value =
            valueFromLocalStorage !== null
              ? valueFromLocalStorage
              : this.dataset.col;
          return value;
        }
      }

      setNumberOfColumns() {
    let colsNumber = this.getNumberOfColumns();

    // Detectar si es móvil (ancho < 768px) y no hay valor en localStorage
    if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
        colsNumber = "1"; // Forzar vista "cols" en móvil
        this.setInLocalStorage(colsNumber);
    } else {
        // En escritorio, usar el valor de localStorage si existe
        if (!["1", "2", "3"].includes(colsNumber)) {
            colsNumber = "3"; // Puedes cambiarlo según la vista por defecto en escritorio
            this.setInLocalStorage(colsNumber);
        }
    }

    this.collectionGrid.style.setProperty("--cols", colsNumber);
    this.changeColorOfButtons();
}



      changeNumberOfColumns(event) {
    const target = event.target.closest(".css-icon--grid, .css-icon--cols, .css-icon--square");
    if (!target) return; // Salir si el clic no fue en un botón válido

    let newValue;
    if (target.classList.contains("css-icon--grid")) {
        newValue = "3";
    } else if (target.classList.contains("css-icon--cols")) {
        newValue = "2";
    } else if (target.classList.contains("css-icon--square")) {
        newValue = "1";
    }

    this.collectionGrid.style.setProperty("--cols", newValue);
    this.setInLocalStorage(newValue);
    this.dataset.col = newValue;
    this.changeColorOfButtons();
}


      changeColorOfButtons() {
        const colsNumber = this.getNumberOfColumns();
        const primaryColor = "var(--color-text)";
        const secondaryColor = "var(--color-border)";
    
        // Eliminar la clase "active" de todos los botones
        this.squareButton.classList.remove("active");
        this.colsButton.classList.remove("active");
        this.gridButton.classList.remove("active");
    
        // Aplicar colores y agregar "active" al botón correspondiente
        if (colsNumber === "1") {
            this.squareButton.style.setProperty("--icon-color", primaryColor);
            this.colsButton.style.setProperty("--icon-color", secondaryColor);
            this.gridButton.style.setProperty("--icon-color", secondaryColor);
            this.squareButton.classList.add("active");
        } else if (colsNumber === "2") {
            this.squareButton.style.setProperty("--icon-color", secondaryColor);
            this.colsButton.style.setProperty("--icon-color", primaryColor);
            this.gridButton.style.setProperty("--icon-color", secondaryColor);
            this.colsButton.classList.add("active");
        } else if (colsNumber === "3") {
            this.squareButton.style.setProperty("--icon-color", secondaryColor);
            this.colsButton.style.setProperty("--icon-color", secondaryColor);
            this.gridButton.style.setProperty("--icon-color", primaryColor);
            this.gridButton.classList.add("active");
        }
    }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    },
  );
}
